import React from "react";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import NumberBox from "../../elements/NumberBox";
import PorosityNumberBox from "../../elements/PorosityNumberBox";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Modal from 'react-bootstrap/Modal';
import './ChannelParametersInputOptions.css';
import VIEW_MODE from '../../common.js';


function getSedimentLabel(extra) {
  return (
    <span>
      {extra} m<span className="supsub">
        <sup>sed</sup>
        <sub>90</sub>
      </span>
    </span>
  );
}

function getManningCoefficientLabel() {
  // m^(1/3)/s
  return (
    <span>
      s/m<span style={{ fontSize: "0.7em", verticalAlign: "top" }}>1/3</span>
    </span>
  );
}

function getSedimentLabelBed() {
  return (
    <span>
      D<span className="supsub">
        <sup>sed</sup>
        <sub>50</sub>
      </span>
    </span>
  );
}

function getD90BedFactorInfo() {
  return (
    <span>Multiplying factor to compute {getD90BedFactor()} from {getSedimentLabelBed()}</span>
  );
}
function getm90BedFactor() {
  return (
    <span>
      m<span className="supsub">
        <sup>sed</sup>
        <sub>90</sub>
      </span>
    </span>
  );
}


function getD90BedFactor() {
  return (
    <span>
      D<span className="supsub">
        <sup>sed</sup>
        <sub>90</sub>
      </span>
    </span>
  );
}

export default function ManningCoefficientInputOptions(props) {
  const parameters = props.parameters;
  const handleTextBoxOnChange = props.handleTextBoxOnChange;
  const view_mode = props.view_mode;


  return (
    <Card>
      <Card.Header>
        Manning Coefficient{" "}
      </Card.Header>
      <Card.Body>
        <Container>
          <Row>
            <Col sm={12}>

              <Form.Group controlId={"manningCoefficientModel"}>
                <Form.Label>Model</Form.Label>
                <div style={{ "position": "relative" }}>
                  <Form.Control
                    name="manningCoefficientModel"
                    as="select"
                    value={parameters["manningCoefficientModel"]}
                    onChange={handleTextBoxOnChange}
                    style={{ "position": "relative" }}
                  >
                    <option value="Rickenmann 1996">Rickenmann 1996</option>
                    <option value="User Defined">User Defined</option>
                  </Form.Control>
                </div>
              </Form.Group>
            </Col>
          </Row>
          <Row>

            {parameters["manningCoefficientModel"] === "User Defined" &&
              <Col sm={12}>

                <Form.Group controlId={"manningCoefficientOptions"}>
                  <Form.Label>Stream bed surface</Form.Label>
                  <div style={{ "position": "relative" }}>
                    <Form.Control
                      name="manningCoefficient"
                      as="select"
                      onChange={handleTextBoxOnChange}
                      style={{ "position": "relative" }}
                    >
                      <option value="0.025">Gravel bottom (n = 0.025 s/m¹⸍³ | K_s = 40.0 m¹⸍³/s)</option>
                      <option value="0.045">Mountain stream with rocky bed (n = 0.045 s/m¹⸍³ | K_s  =22.22 m¹⸍³/s)</option>
                      <option value="0.035">Winding natural stream with weeds (n = 0.035 s/m¹⸍³ | K_s = 28.57 m¹⸍³/s)</option>
                      <option value="0.025">Natural stream with little vegetation (n = 0.025 s/m¹⸍³ | K_s = 40 m¹⸍³/s)</option>
                      <option value="0.02">Straight, unlined earth canal (n = 0.02 s/m¹⸍³ | K_s = 50 m¹⸍³/s)</option>
                      <option value="0.012">Smoothed concrete (n = 0.012 s/m¹⸍³ | K_s = 83.33 m¹⸍³/s)</option>
                    </Form.Control>
                  </div>
                </Form.Group>
              </Col>

            }

            {parameters["manningCoefficientModel"] === "User Defined" &&

              <Col md={6} sm={12}>
                <NumberBox
                  label="Manning Coefficient"
                  controlId="manningCoefficient"
                  unit={getManningCoefficientLabel()}
                  step="0.001"
                  name="manningCoefficient"
                  value={parameters.manningCoefficient}
                  onChange={handleTextBoxOnChange}
                  required={false}
                />
              </Col>
            }

            {parameters["manningCoefficientModel"] === "Rickenmann 1996" && view_mode !== VIEW_MODE.BASIC &&
              <Col md={6} sm={12}>
                <NumberBox
                  label={getm90BedFactor()}
                  controlId="d90BedFactor"
                  info={getD90BedFactorInfo()}
                  unit="-"
                  step="0.0001"
                  name="d90BedFactor"
                  value={parameters.d90BedFactor}
                  onChange={handleTextBoxOnChange}
                />
              </Col>
            }
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
}
